import autobind from 'autobind-decorator'

export const MIN_PASSWORD_LENGTH = 8
const PASSWORD_POLICY_REGEX = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'

export const checkPasswordPolicy = password => {
  const policy = new RegExp(PASSWORD_POLICY_REGEX)
  return policy.test(password)
}

export const generateNewPassword = () => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()'
  const charactersLength = characters.length
  for (let i = 0; i < 8; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

@autobind
class UserService {
  isSuperuser(user = {}) {
    if (user.roles) {
      return user.roles.includes('super-user')
    }
    return false
  }

  isAdmin(user = {}) {
    if (user.roles) {
      return user.roles.includes('admin')
    }
    return false
  }

  isBasicUser(user = {}) {
    if (user.roles) {
      return !user.roles.includes('super-user') && !user.roles.includes('admin')
    }
    return true
  }
}

export default new UserService()
